<template>
  <div>
    <Govem_bar/>
      <v-container fluid class="pa-4">
     <!-- Header Section -->
      <v-alert
  type="error"
  prominent
  outlined
  border="left"
  colored-border
  elevation="2"
  icon="mdi-alert-circle"
>
  <div class="text-subtitle-1 font-weight-medium">
    อยู่ระหว่างดำเนินการพัฒนา
  </div>
  <div class="text-body-2">
    จะเริ่มใช้งานจริงก็ต่อเมื่อมีประกาศจากส่วนกลาง
  </div>
</v-alert>


    <v-card class="mb-4" elevation="2" style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);">

      <v-card-text class="pa-6">
        <v-row align="center">
          <v-col cols="auto">
            <v-avatar size="80" style="border: 3px solid #1976d2;">
              <v-img
                :src="employee.personnel_temporary_pic ? `/hrvecfiles/${employee.personnel_temporary_pic}` : '/default-avatar.png'"
                :alt="employee.frist_names"
              />
            </v-avatar>
          </v-col>
          
          <v-col>
            <h2 class="text-h4 font-weight-light blue--text text--darken-2 mb-2">
              {{ employee.frist_names || 'กำลังโหลด...' }}
            </h2>
            <p class="text-subtitle-1 grey--text text--darken-1 mb-2">
              {{ employee.position_name }}
            </p>
            <div>
              <v-chip small class="mr-2" color="blue" text-color="white">
                <v-icon left small>mdi-card-account-details</v-icon>
                {{ employee.id_card }}
              </v-chip>
              <v-chip small color="green" text-color="white">
                <v-icon left small>mdi-badge-account</v-icon>
                {{ employee.id_position }}
              </v-chip>
            </div>
          </v-col>
          
          <v-col cols="auto">
            <v-btn icon large @click="$router.go(-1)" color="blue darken-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Main Content Tabs -->
    <v-card elevation="3">
      <v-tabs v-model="currentTab" background-color="white" color="primary" grow>
        <v-tab>
          <v-icon left>mdi-account-edit</v-icon>
          ข้อมูลพื้นฐาน
        </v-tab>
        <v-tab>
          <v-icon left>mdi-file-document-multiple</v-icon>
          ประวัติสัญญา
        </v-tab>
        <v-tab>
          <v-icon left>mdi-clock-alert-outline</v-icon>
          การขาดลามาสาย
        </v-tab>
        <v-tab>
          <v-icon left>mdi-chart-line</v-icon>
          ประวัติเงินเดือน
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-remove</v-icon>
          การลาออก
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab">
        <!-- Tab 1: Basic Info -->
        <v-tab-item>
          <BasicInfo 
            :employee="employee"
            :saving="saving"
            @save="saveBasicInfo"
          />
        </v-tab-item>

        <!-- Tab 2: Contract History -->
        <v-tab-item>
          <ContractHistory 
            :contracts="contracts"
            :loading="contractsLoading"
            @add="openContractDialog"
            @edit="editContract"
            @delete="deleteContract"
            @view-file="viewFile"
          />
        </v-tab-item>

        <!-- Tab 3: Attendance History -->
        <v-tab-item>
          <AttendanceHistory 
            :attendances="attendances"
            :summary="attendanceSummary"
            :loading="attendancesLoading"
            @add="openAttendanceDialog"
            @edit="editAttendance"
            @delete="deleteAttendance"
            @view-file="viewFile"
            @filter-changed="onAttendanceFilterChanged"
          />
        </v-tab-item>

        <!-- Tab 4: Salary History -->
        <v-tab-item>
          <SalaryHistory 
            :salaries="salaries"
            :loading="salariesLoading"
            @add="openSalaryDialog"
            @edit="editSalary"
            @delete="deleteSalary"
            @view-file="viewFile"
          />
        </v-tab-item>

        <!-- Tab 5: Resignation -->
        <v-tab-item>
          <ResignationTab 
            :employee="employee"
            :resigning="resigning"
            :canceling="cancelingResignation"
            @resign="processResignation"
            @cancel="cancelResignation"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Contract Dialog -->
    <ContractDialog
      v-model="contractDialog"
      :edit-mode="contractEditMode"
      :data="contractData"
      :saving="contractSaving"
      @save="saveContract"
      @close="closeContractDialog"
    />

    <!-- Attendance Dialog -->
    <AttendanceDialog
      v-model="attendanceDialog"
      :edit-mode="attendanceEditMode"
      :data="attendanceData"
      :saving="attendanceSaving"
      @save="saveAttendance"
      @close="closeAttendanceDialog"
    />

    <!-- Salary Dialog -->
    <SalaryDialog
      v-model="salaryDialog"
      :edit-mode="salaryEditMode"
      :data="salaryData"
      :saving="salarySaving"
      @save="saveSalary"
      @close="closeSalaryDialog"
    />

    <!-- File Preview Dialog -->
    <FilePreviewDialog
      v-model="fileDialog"
      :url="fileUrl"
      :title="fileTitle"
      :type="fileType"
    />

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top right>
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
  </div>

</template>

<script>
// Import child components
import BasicInfo from '../../../components/BasicInfo.vue'
import ContractHistory from '../../../components/ContractHistory.vue'
import AttendanceHistory from '../../../components/AttendanceHistory.vue'
import SalaryHistory from '../../../components/SalaryHistory.vue'
import ResignationTab from '../../../components/ResignationTab.vue'
import ContractDialog from '../../../components/dialogs/ContractDialog.vue'
import AttendanceDialog from '../../../components/dialogs/AttendanceDialog.vue'
import SalaryDialog from '../../../components/dialogs/SalaryDialog.vue'
import FilePreviewDialog from '../../../components/dialogs/FilePreviewDialog.vue'
import Govem_bar from '../../../components/iven/govem_bar.vue'

export default {
  name: 'GovEmId',
  
  components: {
    Govem_bar,
    BasicInfo,
    ContractHistory,
    AttendanceHistory,
    SalaryHistory,
    ResignationTab,
    ContractDialog,
    AttendanceDialog,
    SalaryDialog,
    FilePreviewDialog
  },
  
  data() {
    return {
      // API Configuration
      apiKey: 'HRvec2021',
      baseUrl: '/api',
      
      // Page State
      pageLoading: true,
      currentTab: 0,
      
      // Employee Data
      employee: {},
      
      // Form States
      basicFormValid: false,
      
      // Loading States
      saving: false,
      contractsLoading: false,
      attendancesLoading: false,
      salariesLoading: false,
      contractSaving: false,
      attendanceSaving: false,
      salarySaving: false,
      resigning: false,
      cancelingResignation: false,
      
      // Contract Management
      contracts: [],
      contractDialog: false,
      contractEditMode: false,
      contractData: {
        id: null,
        start_date: '',
        end_date: '',
        order_number: '',
        note: '',
        file: null
      },
      
      // Attendance Management
      attendances: [],
      attendanceSummary: [],
      attendanceDialog: false,
      attendanceEditMode: false,
      attendanceData: {
        id: null,
        attendance_date: '',
        attendance_type: 'late',
        start_time: '08:30',
        actual_time: '',
        duration_minutes: 0,
        reason: '',
        approved_by: '',
        status: 'pending',
        file: null,
        note: ''
      },
      
      // Salary Management
      salaries: [],
      salaryDialog: false,
      salaryEditMode: false,
      salaryData: {
        id: null,
        effective_date: '',
        amount: '',
        order_number: '',
        note: '',
        file: null
      },
      
      // File Preview
      fileDialog: false,
      fileUrl: '',
      fileTitle: '',
      fileType: '',
      
      // Snackbar
      snackbar: {
        show: false,
        text: '',
        color: 'success',
        icon: 'mdi-check-circle'
      }
    }
  },
  
  async mounted() {
    await this.initializeData()
  },
  
  methods: {
    // Initialize Data
    async initializeData() {
      try {
        this.pageLoading = true
        const employeeId = this.$route.params.id || this.$route.query.id
        
        if (!employeeId) {
          this.showError('ไม่พบรหัสพนักงาน')
          return
        }
        await Promise.all([
          this.loadEmployeeData(employeeId),
          this.loadContracts(employeeId),
          this.loadAttendances(employeeId),
          this.loadSalaries(employeeId),
          this.loadAttendanceSummary(employeeId)
        ])
        
      } catch (error) {
        console.error('Initialization error:', error)
        this.showError('เกิดข้อผิดพลาดในการโหลดข้อมูล')
      } finally {
        this.pageLoading = false
      }
    },
    
    // Load Employee Data
    async loadEmployeeData(employeeId) {
      try {
        const response = await this.$http.post('personnel_temporary_govem.php', {
          ApiKey: this.apiKey,
          id_card: employeeId
        })
        if (response.data) {
          this.employee = response.data
        }
      } catch (error) {
        console.error('Load employee error:', error)
        throw error
      }
    },
    
    // Load Contract History
    async loadContracts(employeeId) {
      try {
        this.contractsLoading = true
        const response = await this.$http.post('gov_em_contract_history.php', {
          ApiKey: this.apiKey,
          id_card: employeeId
        })
        
        this.contracts = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.error('Load contracts error:', error)
        this.contracts = []
      } finally {
        this.contractsLoading = false
      }
    },
    
    // Load Attendance History
    async loadAttendances(employeeId, month = null, year = null) {
      try {
        this.attendancesLoading = true
        const response = await this.$http.post('gov_em_attendance_history.php', {
          ApiKey: this.apiKey,
          id_card: employeeId,
          month: month,
          year: year
        })
        
        this.attendances = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.error('Load attendances error:', error)
        this.attendances = []
      } finally {
        this.attendancesLoading = false
      }
    },
    
    // Load Attendance Summary
    async loadAttendanceSummary(employeeId, year = null) {
      try {
        const response = await this.$http.post('gov_em_attendance_summary.php', {
          ApiKey: this.apiKey,
          id_card: employeeId,
          year: year || new Date().getFullYear()
        })
        
        this.attendanceSummary = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.error('Load attendance summary error:', error)
        this.attendanceSummary = []
      }
    },
    
    // Load Salary History
    async loadSalaries(employeeId) {
      try {
        this.salariesLoading = true
        const response = await this.$http.post('gov_em_salary_history.php', {
          ApiKey: this.apiKey,
          id_card: employeeId
        })
        
        this.salaries = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.error('Load salaries error:', error)
        this.salaries = []
      } finally {
        this.salariesLoading = false
      }
    },
    
    // Save Basic Info
    async saveBasicInfo(formData) {
      try {
        this.saving = true
        
        // Upload profile image if selected
        let profileImagePath = null
        if (formData.profileImageFile) {
          profileImagePath = await this.uploadFile(formData.profileImageFile, 'profile')
        }
        
        const updateData = {
          ApiKey: this.apiKey,
          id_card: this.employee.id_card,
          ...formData.basicData
        }
        
        if (profileImagePath) {
          updateData.personnel_temporary_pic = profileImagePath
        }
        
        const response = await this.$http.post('personnel_temporary.update.php', updateData)
        
        if (response.data.status) {
          this.employee = { ...this.employee, ...formData.basicData }
          if (profileImagePath) {
            this.employee.personnel_temporary_pic = profileImagePath
          }
          
          this.showSuccess('บันทึกข้อมูลเรียบร้อย')
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการบันทึก')
        }
        
      } catch (error) {
        console.error('Save basic info error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล')
      } finally {
        this.saving = false
      }
    },
    
    // Contract Management
    openContractDialog() {
      this.contractEditMode = false
      this.contractData = {
        id: null,
        start_date: '',
        end_date: '',
        order_number: '',
        note: '',
        file: null
      }
      this.contractDialog = true
    },
    
    editContract(contract) {
      this.contractEditMode = true
      this.contractData = { ...contract, file: null }
      this.contractDialog = true
    },
    
    closeContractDialog() {
      this.contractDialog = false
    },
    
    async saveContract(contractData) {
      try {
        this.contractSaving = true
        
        // Upload file if selected
        let filePath = null
        if (contractData.file) {
          filePath = await this.uploadFile(contractData.file, 'contract')
        }
        
        const saveData = {
          ApiKey: this.apiKey,
          id_card: this.employee.id_card,
          contract_start_date: contractData.start_date,
          contract_end_date: contractData.end_date,
          contract_order: contractData.order_number,
          contract_note: contractData.note,
          created_by: this.getCurrentUser()
        }
        
        if (filePath) {
          saveData.contract_file = filePath
        }
        
        const endpoint = this.contractEditMode ? 
          'gov_em_contract_history.update.php' : 
          'gov_em_contract_history.insert.php'
          
        if (this.contractEditMode) {
          saveData.id = contractData.id
        }
        
        const response = await this.$http.post(endpoint, saveData)
        
        if (response.data.status) {
          this.showSuccess(`${this.contractEditMode ? 'แก้ไข' : 'เพิ่ม'}สัญญาเรียบร้อย`)
          this.closeContractDialog()
          await this.loadContracts(this.employee.id_card)
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการบันทึก')
        }
        
      } catch (error) {
        console.error('Save contract error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการบันทึกสัญญา')
      } finally {
        this.contractSaving = false
      }
    },
    
    async deleteContract(contract) {
      if (!await this.confirmDelete(`สัญญา ${contract.order_number}`)) return
      
      try {
        const response = await this.$http.post('gov_em_contract_history.delete.php', {
          ApiKey: this.apiKey,
          id: contract.id
        })
        
        if (response.data.status) {
          this.showSuccess('ลบสัญญาเรียบร้อย')
          await this.loadContracts(this.employee.id_card)
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการลบ')
        }
      } catch (error) {
        console.error('Delete contract error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการลบสัญญา')
      }
    },
    
    // Attendance Management
    openAttendanceDialog() {
      this.attendanceEditMode = false
      this.attendanceData = {
        id: null,
        attendance_date: '',
        attendance_type: 'late',
        start_time: '08:30',
        actual_time: '',
        duration_minutes: 0,
        reason: '',
        approved_by: '',
        status: 'pending',
        file: null,
        note: ''
      }
      this.attendanceDialog = true
    },
    
    editAttendance(attendance) {
      this.attendanceEditMode = true
      this.attendanceData = { ...attendance, file: null }
      this.attendanceDialog = true
    },
    
    closeAttendanceDialog() {
      this.attendanceDialog = false
    },
    
    async saveAttendance(attendanceData) {
      try {
        this.attendanceSaving = true
        
        // Upload file if selected
        let filePath = null
        if (attendanceData.file) {
          filePath = await this.uploadFile(attendanceData.file, 'attendance')
        }
        
        const saveData = {
          ApiKey: this.apiKey,
          id_card: this.employee.id_card,
          attendance_date: attendanceData.attendance_date,
          attendance_type: attendanceData.attendance_type,
          start_time: attendanceData.start_time,
          actual_time: attendanceData.actual_time,
          duration_minutes: attendanceData.duration_minutes,
          reason: attendanceData.reason,
          approved_by: attendanceData.approved_by,
          status: attendanceData.status,
          file_path: filePath,
          note: attendanceData.note,
          created_by: this.getCurrentUser()
        }
        
        const endpoint = this.attendanceEditMode ? 
          'gov_em_attendance_history.update.php' : 
          'gov_em_attendance_history.insert.php'
          
        if (this.attendanceEditMode) {
          saveData.id = attendanceData.id
        }
        
        const response = await this.$http.post(endpoint, saveData)
        
        if (response.data.status) {
          this.showSuccess(`${this.attendanceEditMode ? 'แก้ไข' : 'เพิ่ม'}ข้อมูลการขาดลามาสายเรียบร้อย`)
          this.closeAttendanceDialog()
          await this.loadAttendances(this.employee.id_card)
          await this.loadAttendanceSummary(this.employee.id_card)
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการบันทึก')
        }
        
      } catch (error) {
        console.error('Save attendance error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูลการขาดลามาสาย')
      } finally {
        this.attendanceSaving = false
      }
    },
    
    async deleteAttendance(attendance) {
      const typeLabel = attendance.type_label || 'ข้อมูล'
      if (!await this.confirmDelete(`${typeLabel} วันที่ ${this.formatDate(attendance.attendance_date)}`)) return
      
      try {
        const response = await this.$http.post('gov_em_attendance_history.delete.php', {
          ApiKey: this.apiKey,
          id: attendance.id
        })
        
        if (response.data.status) {
          this.showSuccess('ลบข้อมูลเรียบร้อย')
          await this.loadAttendances(this.employee.id_card)
          await this.loadAttendanceSummary(this.employee.id_card)
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการลบ')
        }
      } catch (error) {
        console.error('Delete attendance error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการลบข้อมูล')
      }
    },
    
    // Salary Management
    openSalaryDialog() {
      this.salaryEditMode = false
      this.salaryData = {
        id: null,
        effective_date: '',
        amount: '',
        order_number: '',
        note: '',
        file: null
      }
      this.salaryDialog = true
    },
    
    editSalary(salary) {
      this.salaryEditMode = true
      this.salaryData = { ...salary, file: null }
      this.salaryDialog = true
    },
    
    closeSalaryDialog() {
      this.salaryDialog = false
    },
    
    async saveSalary(salaryData) {
      try {
        this.salarySaving = true
        
        // Upload file if selected
        let filePath = null
        if (salaryData.file) {
          filePath = await this.uploadFile(salaryData.file, 'salary')
        }
        
        const saveData = {
          ApiKey: this.apiKey,
          id_card: this.employee.id_card,
          salary_date: salaryData.effective_date,
          salary_amount: salaryData.amount,
          salary_order: salaryData.order_number,
          salary_note: salaryData.note,
          created_by: this.getCurrentUser()
        }
        
        if (filePath) {
          saveData.salary_file = filePath
        }
        
        const endpoint = this.salaryEditMode ? 
          'gov_em_salary_history.update.php' : 
          'gov_em_salary_history.insert.php'
          
        if (this.salaryEditMode) {
          saveData.id = salaryData.id
        }
        
        const response = await this.$http.post(endpoint, saveData)
        
        if (response.data.status) {
          this.showSuccess(`${this.salaryEditMode ? 'แก้ไข' : 'เพิ่ม'}ข้อมูลเงินเดือนเรียบร้อย`)
          this.closeSalaryDialog()
          await this.loadSalaries(this.employee.id_card)
          
          // Update current salary if adding new record
          if (!this.salaryEditMode) {
            this.employee.salary = salaryData.amount
          }
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการบันทึก')
        }
        
      } catch (error) {
        console.error('Save salary error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูลเงินเดือน')
      } finally {
        this.salarySaving = false
      }
    },
    
    async deleteSalary(salary) {
      if (!await this.confirmDelete(`ข้อมูลเงินเดือน ${this.formatCurrency(salary.amount)}`)) return
      
      try {
        const response = await this.$http.post('gov_em_salary_history.delete.php', {
          ApiKey: this.apiKey,
          salary_id: salary.id
        })
        
        if (response.data.status) {
          this.showSuccess('ลบข้อมูลเงินเดือนเรียบร้อย')
          await this.loadSalaries(this.employee.id_card)
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการลบ')
        }
      } catch (error) {
        console.error('Delete salary error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการลบข้อมูลเงินเดือน')
      }
    },
    
    // Resignation Management
    async processResignation(resignData) {
      if (!await this.confirmAction('ยืนยันการลาออก', `คุณต้องการให้ ${this.employee.frist_names} ลาออกใช่หรือไม่?`)) return
      
      try {
        this.resigning = true
        
        const response = await this.$http.post('personnel_temporary_govem.resign.php', {
          ApiKey: this.apiKey,
          id_card: this.employee.id_card,
          resignation_date: resignData.date,
          resignation_reason: resignData.reason,
          resignation_note: resignData.note
        })
        
        if (response.data.status) {
          this.employee.resignation_date = resignData.date
          this.employee.resignation_reason = resignData.reason
          this.employee.resignation_note = resignData.note
          
          this.showSuccess('ดำเนินการลาออกเรียบร้อย')
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการดำเนินการ')
        }
        
      } catch (error) {
        console.error('Process resignation error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการดำเนินการลาออก')
      } finally {
        this.resigning = false
      }
    },
    
    async cancelResignation() {
      if (!await this.confirmAction('ยืนยันการยกเลิก', `คุณต้องการยกเลิกการลาออกของ ${this.employee.frist_names} ใช่หรือไม่?`)) return
      
      try {
        this.cancelingResignation = true
        
        const response = await this.$http.post('personnel_temporary_govem.cancel_resign.php', {
          ApiKey: this.apiKey,
          id_card: this.employee.id_card
        })
        
        if (response.data.status) {
          this.employee.resignation_date = null
          this.employee.resignation_reason = null
          this.employee.resignation_note = null
          
          this.showSuccess('ยกเลิกการลาออกเรียบร้อย')
        } else {
          throw new Error(response.data.message || 'เกิดข้อผิดพลาดในการดำเนินการ')
        }
        
      } catch (error) {
        console.error('Cancel resignation error:', error)
        this.showError(error.message || 'เกิดข้อผิดพลาดในการยกเลิกการลาออก')
      } finally {
        this.cancelingResignation = false
      }
    },
    
    // Event Handlers
    onAttendanceFilterChanged(filters) {
      this.loadAttendances(this.employee.id_card, filters.month, filters.year)
      if (filters.year) {
        this.loadAttendanceSummary(this.employee.id_card, filters.year)
      }
    },
    
    viewFile(filePath, title) {
      this.fileUrl = `/files/${filePath}`
      this.fileTitle = title
      this.fileType = this.getFileType(filePath)
      this.fileDialog = true
    },
    
    // File Management
    async uploadFile(file, type) {
      try {
        const formData = new FormData()
        const timestamp = Date.now()
        const extension = file.name.split('.').pop()
        const filename = `${type}_${this.employee.id_card}_${timestamp}.${extension}`
        
        formData.append('ApiKey', this.apiKey)
        formData.append('file', file)
        formData.append('filename', filename)
        formData.append('type', type)
        
        const response = await this.$http.post('uploadfile.php', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        
        if (response.data.status) {
          return filename
        } else {
          throw new Error(response.data.message || 'Upload failed')
        }
        
      } catch (error) {
        console.error('Upload file error:', error)
        throw new Error('เกิดข้อผิดพลาดในการอัปโหลดไฟล์')
      }
    },
    
    getFileType(filePath) {
      const extension = filePath.split('.').pop().toLowerCase()
      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
        return 'image'
      } else if (extension === 'pdf') {
        return 'pdf'
      }
      return 'other'
    },
    
    // Utilities
    getCurrentUser() {
      try {
        const user = JSON.parse(sessionStorage.getItem('user') || '{}')
        return user.frist_names || user.name || 'Admin'
      } catch {
        return 'Admin'
      }
    },
    
    async confirmDelete(itemName) {
      try {
        if (this.$swal) {
          const result = await Swal.fire({
            title: 'ยืนยันการลบ',
            text: `คุณต้องการลบ${itemName} ใช่หรือไม่?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#757575',
            confirmButtonText: 'ลบ',
            cancelButtonText: 'ยกเลิก'
          })
          return result.isConfirmed
        }
        return confirm(`คุณต้องการลบ${itemName} ใช่หรือไม่?`)
      } catch {
        return confirm(`คุณต้องการลบ${itemName} ใช่หรือไม่?`)
      }
    },
    
    async confirmAction(title, text) {
      try {
        if (this.$swal) {
          const result = await Swal.fire({
            title: title,
            text: text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#1976d2',
            cancelButtonColor: '#757575',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          })
          return result.isConfirmed
        }
        return confirm(text)
      } catch {
        return confirm(text)
      }
    },
    
    showSuccess(message) {
      this.snackbar = {
        show: true,
        text: message,
        color: 'success',
        icon: 'mdi-check-circle'
      }
    },
    
    showError(message) {
      this.snackbar = {
        show: true,
        text: message,
        color: 'error',
        icon: 'mdi-alert-circle'
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        return new Date(dateString).toLocaleDateString('th-TH')
      } catch {
        return dateString
      }
    },
    
    formatDateTime(dateString) {
      if (!dateString) return ''
      try {
        return new Date(dateString).toLocaleString('th-TH')
      } catch {
        return dateString
      }
    },
    
    formatCurrency(amount) {
      if (!amount) return '฿0'
      return new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
        minimumFractionDigits: 0
      }).format(amount)
    },
    
    formatTime(timeString) {
      if (!timeString) return ''
      try {
        return timeString.slice(0, 5)
      } catch {
        return timeString
      }
    }
  }
}
</script>

<style scoped>
/* Clean white theme */
.v-application {
  background: #fafafa !important;
}

.v-card {
  background: white !important;
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

.v-data-table {
  background: white !important;
  border-radius: 8px;
}

.v-data-table thead tr th {
  background: #f8f9fa !important;
  font-weight: 600 !important;
}

.v-data-table tbody tr:hover {
  background: #f5f5f5 !important;
}

.v-tabs {
  background: white !important;
}

.v-tab {
  text-transform: none !important;
  font-weight: 500 !important;
}

.v-btn {
  text-transform: none !important;
  font-weight: 500 !important;
}

.v-chip {
  font-weight: 500 !important;
}

.v-dialog > .v-card {
  border-radius: 12px !important;
}

.v-snackbar {
  font-weight: 500 !important;
}

/* Form improvements */
.v-text-field--outlined fieldset {
  border-color: #e0e0e0 !important;
}

.v-text-field--outlined:not(.v-input--is-focused) .v-label {
  color: #616161 !important;
}

/* Tab specific styling */
.v-tab--active {
  color: #1976d2 !important;
}

.v-tabs-slider {
  background-color: #1976d2 !important;
}

/* Data table enhancements */
.v-data-table .v-data-table__wrapper {
  border-radius: 8px;
}

.v-data-table tbody tr {
  transition: background-color 0.2s ease;
}

/* Chip styling */
.v-chip.v-size--small {
  height: 24px;
  font-size: 12px;
}

/* Button styling */
.v-btn--icon.v-size--small {
  width: 32px;
  height: 32px;
}

/* Alert styling */
.v-alert {
  border-radius: 8px;
}

/* Card title styling */
.v-card__title {
  border-radius: 4px 4px 0 0;
}

/* Loading overlay */
.v-overlay {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

/* Snackbar positioning */
.v-snack {
  z-index: 9999;
}

/* File input styling */
.v-file-input .v-file-input__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Avatar border enhancement */
.v-avatar img {
  object-fit: cover;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .v-container {
    padding: 8px !important;
  }
  
  .v-card-text {
    padding: 16px !important;
  }
  
  .v-tabs {
    overflow-x: auto;
  }
  
  .v-tab {
    min-width: 120px;
  }
}

@media (max-width: 600px) {
  .v-card-text {
    padding: 12px !important;
  }
  
  .text-h4 {
    font-size: 1.5rem !important;
  }
  
  .v-avatar {
    width: 60px !important;
    height: 60px !important;
  }
}

/* Print styles */
@media print {
  .v-btn,
  .v-tabs,
  .v-overlay {
    display: none !important;
  }
  
  .v-card {
    box-shadow: none !important;
    border: 1px solid #ddd;
  }
}
</style>